var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8484_110198)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    transform: "translate(-299 -93)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 165,
    transform: "translate(-299 -93)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -283,
    y: 11,
    width: 343,
    height: 46,
    rx: 8,
    fill: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8484_110198)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8484_110198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -284,
    y: -78,
    width: 345,
    height: 782,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -284,
    y: -78,
    width: 345,
    height: 90,
    fill: "#F1F4F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8484_110198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -266,
    y: -14,
    width: 310,
    height: 55,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.328 26.1152C19.0518 26.1152 18.828 26.3391 18.828 26.6152C18.828 26.8914 19.0518 27.1152 19.328 27.1152V26.1152ZM27.1154 17.5059C27.1154 17.2298 26.8915 17.0059 26.6154 17.0059C26.3393 17.0059 26.1154 17.2298 26.1154 17.5059H27.1154ZM8.39681 27.1152C8.67295 27.1152 8.89681 26.8914 8.89681 26.6152C8.89681 26.3391 8.67295 26.1152 8.39681 26.1152V27.1152ZM1.60938 17.5059C1.60938 17.2298 1.38552 17.0059 1.10938 17.0059C0.833233 17.0059 0.609375 17.2298 0.609375 17.5059H1.60938ZM8.39681 1.60921C8.67295 1.60921 8.89681 1.38536 8.89681 1.10921C8.89681 0.833071 8.67295 0.609215 8.39681 0.609215V1.60921ZM0.609375 10.2185C0.609375 10.4946 0.833233 10.7185 1.10938 10.7185C1.38552 10.7185 1.60938 10.4946 1.60938 10.2185H0.609375ZM19.328 0.609215C19.0518 0.609215 18.828 0.833071 18.828 1.10921C18.828 1.38536 19.0518 1.60921 19.328 1.60921V0.609215ZM26.1154 10.2185C26.1154 10.4946 26.3393 10.7185 26.6154 10.7185C26.8915 10.7185 27.1154 10.4946 27.1154 10.2185H26.1154ZM19.328 27.1152C23.6288 27.1152 27.1154 23.6287 27.1154 19.3278H26.1154C26.1154 23.0764 23.0766 26.1152 19.328 26.1152V27.1152ZM27.1154 19.3278V17.5059H26.1154V19.3278H27.1154ZM8.39681 26.1152C4.64821 26.1152 1.60938 23.0764 1.60938 19.3278H0.609375C0.609375 23.6287 4.09593 27.1152 8.39681 27.1152V26.1152ZM1.60938 19.3278V17.5059H0.609375L0.609375 19.3278H1.60938ZM8.39681 0.609215C4.09593 0.609215 0.609375 4.09577 0.609375 8.39665H1.60938C1.60938 4.64805 4.64821 1.60921 8.39681 1.60921V0.609215ZM0.609375 8.39665L0.609375 10.2185H1.60938L1.60938 8.39665H0.609375ZM19.328 1.60921C23.0766 1.60921 26.1154 4.64805 26.1154 8.39665H27.1154C27.1154 4.09577 23.6288 0.609215 19.328 0.609215V1.60921ZM26.1154 8.39665V10.2185H27.1154V8.39665H26.1154Z",
    fill: "#3D4C66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9411 12.8843C16.2287 12.8756 15.6574 12.2926 15.6631 11.5802C15.6689 10.8677 16.2496 10.294 16.962 10.2969C17.6745 10.2997 18.2505 10.8781 18.2506 11.5905C18.246 12.3093 17.6599 12.8883 16.9411 12.8843V12.8843Z",
    stroke: "#3D4C66",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02881 12.022V17.1981C6.04035 19.115 7.60341 20.6598 9.52036 20.6488H18.2497C19.1705 20.6543 20.0557 20.2939 20.7107 19.6468C21.3657 18.9996 21.7368 18.1188 21.7423 17.1981V12.022C21.7308 10.1051 20.1677 8.56032 18.2508 8.57135H9.52036C7.60341 8.56032 6.04035 10.1051 6.02881 12.022Z",
    stroke: "#3D4C66",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1392 18.0602C10.7137 18.0435 9.57001 16.8772 9.58114 15.4516C9.59226 14.0261 10.754 12.8778 12.1796 12.8833C13.6052 12.8888 14.758 14.046 14.7581 15.4717C14.7543 16.1623 14.4761 16.823 13.985 17.3085C13.4938 17.794 12.8298 18.0644 12.1392 18.0602Z",
    stroke: "#3D4C66",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2666 8.57147V6.84612C11.2677 6.61589 11.3603 6.39555 11.524 6.23364C11.6877 6.07173 11.909 5.98153 12.1392 5.98293H15.6318C15.862 5.98153 16.0834 6.07173 16.2471 6.23364C16.4107 6.39555 16.5033 6.61589 16.5044 6.84612V8.57147",
    stroke: "#3D4C66",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8484_110198",
    x: -314,
    y: -98,
    width: 405,
    height: 842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8484_110198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8484_110198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8484_110198",
    x: -291,
    y: -34,
    width: 360,
    height: 105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8484_110198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8484_110198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8484_110198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "white",
    transform: "translate(-299 -93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8484_110198"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -284,
    y: -78,
    width: 345,
    height: 782,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.2db323231cf36d15d9f20730f50dc6cf.svg";
export { ForwardRef as ReactComponent };